//消息提示
import { message } from 'ant-design-vue';
export function msgWarning (msg) {
  message.warning(msg,3)
}

export function msgError (msg) {
  message.error(msg,3)
}

export function msgInfo (msg) {
  message.info(msg,3)
}

//请求地址
// export const url =  'http://192.168.3.185:8080'
export const url =  'http://192.168.3.118:8080'
//export const url =  'http://192.168.3.39:8080'

//export const url_glass = 'http://192.168.3.63:8080'

export const url_glass = 'http://212.129.247.206:8080'

export const url_screen = 'http://192.168.3.63:8088'
//车间信息

export const workShop = ['新一车间','新二车间','高精密复合加工车间','铸造车间']





// WEBPACK FOOTER //
// ./src/common.js